import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { ReportsService } from '../../../shared/services/reports.service';
import { ReportModel } from "../../../shared/classes/ReportModel";
import { FiltroModel } from "../../../shared/classes/FiltroModel";
import { Router, NavigationExtras } from "@angular/router";
import { PaginationInstance } from "ngx-pagination";
import { Adal4Service } from "adal-angular4";
import { GroupModel } from "../../../shared/classes/GroupModel";
import { GroupsService } from "../../../shared/services/groups.service";


@Component({
  selector: 'app-edit-del-relatorios',
  templateUrl: './edit-del-relatorios.component.html',
  styleUrls: ['./edit-del-relatorios.component.css'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [GroupsService]
})
export class EditDelRelatoriosComponent implements OnInit {
  idReportToDelete: number;
  msgAviso: string;
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  class_icon_msg: string;
  @Input('data') listaReports: ReportModel[] = [];
  mostrarCarregando = false;
  listaGrupos: GroupModel[] = [];
  nameReportToDelete: string;
  nivelPermissao: string = "Consultar";
  //paginação
  public filter: string = '';
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;

  public config: PaginationInstance = {
    id: 'advanced',
    itemsPerPage: 20,
    currentPage: 1
  };

  public labels: any = {
    previousLabel: 'Anterior',
    nextLabel: 'Próxima',
    screenReaderPaginationLabel: 'Pagination',
    screenReaderPageLabel: 'page',
    screenReaderCurrentLabel: `You're on page`
  };

  private popped = []; 
  //fim paginação
  selectedReport: ReportModel = new ReportModel();
  msgErro: string;

  id: number;
  constructor(
    private router: Router, 
    private _reportService: ReportsService, 
    private adalService: Adal4Service,
    private groupsService: GroupsService) {

  }


  ngOnInit() {
    this.mostrarCarregando = true;
    this.getReports();    
    this.resetSelectedReport();
  }

  getReportAdditionalInfo(id: number) {
    this.initializeSelectedReport(id).then(() => {     
      document.getElementById("showReportDetails").click();
    })
  }

    setReportToDelete(id: number){
    let relSelecionado = this.listaReports.filter(r => r.id == id);
    this.idReportToDelete = id;
    this.nameReportToDelete = relSelecionado[0].reportTitle;
    //console.log("this.indexReportToDelete: ", this.indexReportToDelete);
  }
   onPageChange(number: number) {
    //console.log('change to page', number);
    this.config.currentPage = number;
  }

  pushItem() {
    let item = this.popped.pop() || 'A newly-created report!';
    this.listaReports.push(item);
  }

  popItem() {
    this.popped.push(this.listaReports.pop());
  }



  editReport(id: number) {
    let relSelecionado = this.listaReports.filter(r => r.id == id);
    this.initializeSelectedReport(relSelecionado[0].id).then(() => {
      this._reportService.setSelectedReport(this.selectedReport);      
      this.router.navigate(['/editarrelatorio'],{ queryParams: { rid: id }});      
    });
  }

  getReports(){
    this._reportService.getReports()
      .then(reports => {       
        reports.forEach(report => {
          var dataCreatedOn = new Date(report.createdOn);
          var data = dataCreatedOn.toLocaleDateString();
          var hora = dataCreatedOn.toLocaleTimeString();
          report.createdOn = `${data} ${hora}`;
          report.accessGroups.forEach(ag => {
            //console.log("AG", ag);
            if(ag.roleName.indexOf("Cadastro") > -1){
              //console.log("É CADASTRO");
              report.isGrupoCadastro = true;
            }
          });
          // if(report.accessGroups.roleName.indexOf("Cadastro") > -1){
          //   console.log("É CADASTRO");
          // }
        }); 
        this.loadGroups();
       
        this.listaReports = reports;
        //console.log("REPORTS", reports);
        this.mostrarCarregando = false;
      }).catch(erro => {
        
        this.msgAviso = <any>erro;
        this.class_icon_msg = this.class_fa_icon_nok;
        if(erro.status == 403){
          this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
          //this.router.navigate(['/home']); 
          return;
        }

        document.getElementById("showMensagensModal2").click();
      });
  }
  
  initializeSelectedReport(id: number) {
    //console.log("Id do relatorio selecionado:", id);
    let relSelecionado = this.listaReports.filter(r => r.id == id);//[index].id;
    //console.log("SELECTED REPORT", relSelecionado);
    this.resetSelectedReport();
    return this._reportService.getReportById(relSelecionado[0].id)
      .then(report => {
        //console.log("Report from service: ",report);
        this.selectedReport.reportTitle = relSelecionado[0].reportTitle;
        this.selectedReport.id = relSelecionado[0].id;
        this.selectedReport.reportQuery = report.reportQuery;
        this.selectedReport.reportFilters = report.reportFilters;
        this.selectedReport.hasFilters = report.hasFilters;
        this.selectedReport.accessGroups = report.accessGroups;
        this.selectedReport.connectionId = report.connectionId;
        //console.log("[initializeSelectedReport]", this.selectedReport);
        this.setSelectedGroups();
      }).catch(erro =>{
        this.msgAviso = <any>erro;
        if(erro.status == 403 || erro.status == 401){
          this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
          //this.router.navigate(['/home']);           
        }
        this.class_icon_msg = this.class_fa_icon_nok;
        document.getElementById("showMensagensModal2").click()
      })
  }

  resetSelectedReport() {
    this.selectedReport.reportTitle = "Carregando..";
    this.selectedReport.reportQuery = "";
    this.selectedReport.reportFilters = [];
    this.selectedReport.accessGroups = [];
  }

  setSelectedGroups(){
    //console.log("chamou setSelectedGroups")
    var nomesGruposDoRelatorio =  this.selectedReport.accessGroups.map((ag) => ag.roleName);
    //console.log("selectedReport.accessGroups:", this.selectedReport.accessGroups);    
    this.deselectAllGroups();
    //console.log("this.listaGrupos:", this.listaGrupos);    
    this.listaGrupos.forEach(grupo => {   
      if(grupo.displayName.toLowerCase().indexOf('consulta') > -1){
        grupo.displayName = grupo.displayName.split(" ")[1];
      }   
      if(nomesGruposDoRelatorio.some((nome) => nome == grupo.value)){
        grupo.selected = true;        
      }
    });   
  }
   
  deselectAllGroups(){
    this.listaGrupos.forEach(grupo => {      
      grupo.selected = false;
    });
  }

  deleteReport(){
    //console.log("Chamou o deleteReport");
    //console.log("this.indexReportToDelete", this.indexReportToDelete);
    if(this.idReportToDelete >= 0){

       let reportToDelete = this.listaReports.filter(r => r.id == this.idReportToDelete);
      //console.log("reportToDelete", reportToDelete);
      this._reportService.deleteReport(reportToDelete[0].id).then(() => {
        
        this.listaReports.splice(this.listaReports.indexOf(reportToDelete[0]), 1);
        
        this.msgAviso = "Relatório excluido com sucesso";
        this.class_icon_msg = this.class_fa_icon_ok;
        document.getElementById("showMensagensModal2").click();
        this.eraseReportToDelete();
      }, erro => {
        this.msgAviso = <any>erro;
        if(erro.status == 403 || erro.status == 401){
          this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
          //this.router.navigate(['/home']);           
        }
        this.class_icon_msg = this.class_fa_icon_nok;
        document.getElementById("showMensagensModal2").click()
      })
    }
  }



  eraseReportToDelete(){
    this.idReportToDelete = null;
  }

  loadGroups(){    
    // var grupoStorage = localStorage.getItem("grupos");
    // if (grupoStorage){
    //   this.listaGrupos = JSON.parse(grupoStorage);
    //   console.log("listagroups storage", this.listaGrupos);
    //   return;
    // }
    this.groupsService.getGroups().then(grupos =>{         
      this.listaGrupos = grupos;
      //console.log("listagroups depois do serviço", this.listaGrupos);
    }).catch(erro => {
      this.msgAviso = erro.text() || <any>erro;
      if(erro.status == 403 || erro.status == 401){
        this.msgAviso = "Sua sessão expirou ou você não tem permissão para acessar este recurso.";
        //this.router.navigate(['/home']);           
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal4").click();
    });
  }

  getIndexAccordingToPage(i: number){
    var currentPage = this.config.currentPage;
    var pageSize = this.config.itemsPerPage;
    return ((currentPage - 1) * pageSize) + i;
  }

}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/relatorios/edit-del-relatorios/edit-del-relatorios.component.ts